import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X, Star, Shield, Clock, Lock, CreditCard, ChevronDown, ArrowRight, FileText, Zap, MapPin, Package, AlertCircle } from 'lucide-react';
// --- DATA ARRAYS ---
const TESTIMONIALS_HERO = [{
  initials: 'MG',
  name: 'Marcos G.',
  loc: 'Buenos Aires',
  img: 'https://randomuser.me/api/portraits/men/32.jpg',
  text: 'Arranqué con el Tomo 1 un sábado. El domingo siguiente ya tenía mis primeros 10 pedidos confirmados. El sistema funciona.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  loc: 'Rosario',
  img: 'https://randomuser.me/api/portraits/women/44.jpg',
  text: 'El Tomo 3 me salvó la vida. Antes vendía sin saber si ganaba o perdía. Ahora sé exactamente cuánto me cuesta cada burger y cuánto gano.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  loc: 'Córdoba',
  img: 'https://randomuser.me/api/portraits/men/15.jpg',
  text: 'Pensé que era solo recetas. Es un sistema completo de negocio. Llevo 3 meses vendiendo y el cupo se llena todos los viernes.'
}];
const PAIN_POINTS = ['Comprás carne sin saber el blend correcto y la burger no tiene el sabor esperado.', 'Ponés precios por intuición y no entendés por qué trabajás tanto y ganás poco.', 'El primer viernes de alta demanda colapsás por falta de un sistema de producción.', 'No sabés cómo fotografiar tus burgers y el menú no atrae clientes.', 'Querés vender pero te faltan las palabras para comunicar el valor de tu producto.', 'Fin de semana agotado, el lunes volvés a empezar el mismo ciclo sin avanzar.'];
const TOMOS = [{
  id: 1,
  color: 'border-blue-500',
  title: 'La Base',
  subtitle: 'Infraestructura Hogareña',
  desc: 'Equipamiento, espacio de trabajo y adaptación profesional del hogar. Seguridad e higiene doméstica.'
}, {
  id: 2,
  color: 'border-orange-500',
  title: 'El Alquimista',
  subtitle: 'Ingeniería de Menú',
  desc: 'Los mejores blends para Argentina. Pan Kalis, queso Milkaut y salsas firma. Smash vs medallón clásico.'
}, {
  id: 3,
  color: 'border-red-500',
  title: 'El Contador',
  subtitle: 'Costos e Inflación',
  desc: 'Fichas técnicas, cálculo de margen real y actualización de precios. Manejo de proveedores y planillas.'
}, {
  id: 4,
  color: 'border-emerald-500',
  title: 'El Operador',
  subtitle: 'Producción en Serie',
  desc: 'Mise en place profesional. Sistema de producción escalonada y gestión del servicio de alta demanda.'
}, {
  id: 5,
  color: 'border-amber-500',
  title: 'El Vendedor',
  subtitle: 'Marketing de Barrio',
  desc: 'Instagram gastronómico, fotografía con celular y scripts de WhatsApp. Promociones que funcionan.'
}, {
  id: 6,
  color: 'border-cyan-500',
  title: 'El Dueño',
  subtitle: 'Delivery y Escalado',
  desc: 'Packaging térmico, logística de reparto y marco legal argentino. Estrategia de escalado inteligente.'
}];
const BONOS = [{
  id: 1,
  title: 'Kit Express de Arranque en 72 Horas',
  desc: 'De cero a tu primer pedido real en 3 días con un plan simple.',
  value: '$8.000'
}, {
  id: 2,
  title: 'Menú Mínimo Ganador',
  desc: 'Cómo armar un menú corto, vendible y rentable. 100 nombres incluidos.',
  value: '$10.000'
}, {
  id: 3,
  title: 'Checklist Maestro de Producción',
  desc: 'Checklists de apertura, servicio y cierre listos para imprimir.',
  value: '$9.000'
}, {
  id: 4,
  title: 'Pack de Copy para Vender',
  desc: '100 nombres, 50 descripciones y scripts listos para copiar y pegar.',
  value: '$8.000'
}, {
  id: 5,
  title: '20 Promociones de Lanzamiento',
  desc: 'Sistema de promos inteligentes para arrancar sin destruir el margen.',
  value: '$9.000'
}, {
  id: 6,
  title: 'Guía de Errores que te Hacen Perder Plata',
  desc: '30 módulos con los errores más comunes y sus soluciones exactas.',
  value: '$9.000'
}];
const COMPARISON = [{
  sit: 'Actualización de precios',
  sin: 'Improvisás y perdés margen',
  con: 'Sistema con alertas de inflación'
}, {
  sit: 'Implementación de delivery',
  sin: 'Logística improvisada',
  con: 'Protocolo profesional paso a paso'
}, {
  sit: 'Gestión de alta demanda',
  sin: 'Perdés clientes por falta de cupo',
  con: 'Sistema de lista de espera VIP'
}, {
  sit: 'Contratación de personal',
  sin: 'Trabajás solo al límite',
  con: 'Guía de primer empleado'
}, {
  sit: 'Formalización del negocio',
  sin: 'Trámites postergados',
  con: 'Roadmap legal y fiscal completo'
}, {
  sit: 'Apertura de local propio',
  sin: 'Decisiones sin información',
  con: 'Calculadora de punto de equilibrio'
}];
const TESTIMONIALS_MORE = [{
  init: 'CR',
  name: 'Cecilia R.',
  loc: 'Mendoza',
  pack: 'MegaPack Pro',
  img: 'https://randomuser.me/api/portraits/women/68.jpg',
  text: 'El Tomo 3 me cambió la vida. Ahora tengo fichas técnicas de cada burger y sé exactamente qué gano.'
}, {
  init: 'RM',
  name: 'Roberto M.',
  loc: 'Buenos Aires',
  pack: 'MegaPack Completo',
  img: 'https://randomuser.me/api/portraits/men/52.jpg',
  text: 'El sistema de mise en place convirtió mi cocina en una línea de producción. Paso de 15 a 40 burgers por noche.'
}, {
  init: 'SC',
  name: 'Sofía C.',
  loc: 'La Plata',
  pack: 'MegaPack Completo',
  img: 'https://randomuser.me/api/portraits/women/24.jpg',
  text: 'Los scripts de WhatsApp casi duplicaron mi tasa de conversión de consultas a pedidos.'
}, {
  init: 'PA',
  name: 'Pablo A.',
  loc: 'Neuquén',
  pack: 'MegaPack Pro',
  img: 'https://randomuser.me/api/portraits/men/76.jpg',
  text: 'El sistema de blend fue un antes y un después. Mis burgers tienen una costra y sabor únicos en el barrio.'
}, {
  init: 'VT',
  name: 'Valeria T.',
  loc: 'Rosario',
  pack: 'MegaPack Completo',
  img: 'https://randomuser.me/api/portraits/women/90.jpg',
  text: 'El Kit de 72 Horas me obligó a arrancar. Tres días después tenía mi primer pedido real.'
}, {
  init: 'JM',
  name: 'Julián M.',
  loc: 'Córdoba',
  pack: 'MegaPack Pro',
  img: 'https://randomuser.me/api/portraits/men/85.jpg',
  text: 'El Tomo 5 me enseñó a fotografiar con el celular. El cupo se llenó en 2 horas el siguiente fin de semana.'
}];
const FAQS = [{
  q: '¿Sirve si nunca hice hamburguesas antes?',
  a: 'Sí. El sistema está diseñado para emprendedores desde cero. El Tomo 1 empieza por el equipamiento mínimo y el Bono 1 te guía en las primeras 72 horas.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en PDF. Al confirmar el pago recibís el acceso inmediato en tu email. Podés leerlo desde cualquier dispositivo.'
}, {
  q: '¿Qué lo diferencia de recetas de YouTube?',
  a: 'YouTube te da recetas. Nosotros te damos un sistema de negocio: costos, fichas técnicas, producción, ventas y escalado. Es la diferencia entre cocinar y emprender.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas. Nuestra tasa de devoluciones es menor al 1%.'
}, {
  q: '¿Los insumos se consiguen en Argentina?',
  a: 'Todo está construido sobre insumos reales del mercado argentino (Pan Kalis, Queso Milkaut, cortes de carnicería de barrio). No hay ingredientes importados difíciles de conseguir.'
}, {
  q: '¿Sirve si ya tengo una hamburguesería funcionando?',
  a: 'Sí, especialmente los tomos de costos, producción en volumen y escalado. Muchos emprendedores lo usan para profesionalizar su negocio actual.'
}];
const COST_INACTION = [{
  sin: 'Precios puestos por intuición',
  costo: 'Miles de pesos de ganancia perdida'
}, {
  sin: 'Producción sin sistema',
  costo: 'Horas de caos en cada servicio'
}, {
  sin: 'Fotos de baja calidad',
  costo: 'Clientes que no te eligen'
}, {
  sin: 'Sin scripts de venta',
  costo: 'Consultas que no convierten'
}, {
  sin: 'Insumos mal comprados',
  costo: 'Burgers sin identidad'
}, {
  sin: 'Fin de semana agotado',
  costo: 'El mismo ciclo sin avanzar'
}];
// --- COMPONENTS ---
const ButtonCTA = ({
  children,
  href = '#pricing',
  variant = 'primary',
  className = ''
}: any) => {
  const baseStyle = 'inline-flex items-center justify-center font-medium tracking-wide text-lg py-4 px-8 rounded-xl transition-all duration-200 w-full md:w-auto text-center shadow-sm hover:shadow-lg hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-brand-accent text-white hover:bg-brand-accent/90',
    orange: 'bg-brand-orange text-white hover:bg-brand-orange/90 shadow-brand-orange/20',
    gold: 'bg-brand-gold text-white hover:bg-brand-gold/90',
    outline: 'bg-white/5 border border-white/20 text-stone-100 hover:bg-white/10 hover:border-white/30'
  };
  return <a href={href} className={`${baseStyle} ${variants[variant as keyof typeof variants]} ${className}`} data-id="element-2">
      {children}
    </a>;
};
// Avatar with graceful fallback to initials if image fails to load
const Avatar = ({
  src,
  name,
  initials,
  sizeClass = 'w-10 h-10'
}: {
  src: string;
  name: string;
  initials: string;
  sizeClass?: string;
}) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return <div className={`${sizeClass} bg-white/10 text-brand-gold rounded-full flex items-center justify-center font-display text-sm ring-1 ring-white/10 flex-shrink-0`} data-id="element-3">
        {initials}
      </div>;
  }
  return <img src={src} alt={`Foto de ${name}`} onError={() => setFailed(true)} className={`${sizeClass} rounded-full object-cover ring-1 ring-white/10 flex-shrink-0`} data-id="element-4" />;
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const Tile = ({
    value,
    label,
    accent = false
  }: {
    value: number;
    label: string;
    accent?: boolean;
  }) => <div className="bg-white/5 border border-white/10 rounded-lg w-16 h-16 flex flex-col items-center justify-center" data-id="element-5">
      <span className={accent ? 'text-brand-orange' : 'text-stone-100'} data-id="element-6">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-sans text-stone-500 uppercase tracking-wider" data-id="element-7">
        {label}
      </span>
    </div>;
  return <div className="flex items-center justify-center gap-3 font-display text-2xl md:text-3xl my-6" data-id="element-8">
      <Tile value={timeLeft.h} label="Horas" data-id="element-9" />
      <span className="text-stone-600 pb-4" data-id="element-10">:</span>
      <Tile value={timeLeft.m} label="Min" data-id="element-11" />
      <span className="text-stone-600 pb-4" data-id="element-12">:</span>
      <Tile value={timeLeft.s} label="Seg" accent data-id="element-13" />
    </div>;
};
const FAQItem = ({
  q,
  a
}: {
  q: string;
  a: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="mb-3 border border-white/10 rounded-xl bg-white/5 overflow-hidden" data-id="element-14">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left font-semibold text-stone-100 hover:bg-white/5 transition-colors" data-id="element-15">
        <span data-id="element-16">{q}</span>
        <ChevronDown className={`text-stone-400 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-17" />
      </button>
      <AnimatePresence data-id="element-18">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="px-5 pb-5 text-stone-400 leading-relaxed text-sm" data-id="element-19">
            {a}
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function LandingPage() {
  return <div className="min-h-screen font-sans selection:bg-brand-orange/30 selection:text-white overflow-x-hidden bg-[#14110F] text-stone-200" data-id="element-20">
      {/* HERO SECTION */}
      <section className="relative pt-16 pb-24 px-4 overflow-hidden" data-id="element-21">
        {/* Gastronomy ambiance background */}
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1551782450-a2132b4ba21d?q=80&w=2000&auto=format&fit=crop')"
      }} aria-hidden="true" data-id="element-22"></div>
        <div className="absolute inset-0 bg-[#14110F]/90" aria-hidden="true" data-id="element-23"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#14110F]/70 via-[#14110F]/85 to-[#14110F]" aria-hidden="true" data-id="element-24"></div>

        <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-25">
          <div className="text-left order-2 lg:order-1" data-id="element-26">
            <div className="mb-6" data-id="element-27">
              <span className="inline-flex items-center gap-2 bg-brand-orange/15 border border-brand-orange/30 text-brand-orange px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-28">
                Master Burger Argentina™
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display mb-6 text-white leading-[1.1]" data-id="element-29">
              Todo lo que necesitás para arrancar tu{' '}
              <span className="text-brand-orange" data-id="element-30">hamburguesería casera.</span>
            </h1>

            <p className="text-stone-300 mb-8 font-light text-base md:text-lg leading-relaxed" data-id="element-31">
              El sistema integral para emprendedores gastronómicos en Argentina.
              Recetas, costos, operación y ventas listos para usar. Sin
              improvisar.
            </p>

            <div className="flex flex-wrap gap-3 mb-10" data-id="element-32">
              {[{
              icon: FileText,
              text: '100% Digital'
            }, {
              icon: Zap,
              text: 'Acceso Inmediato'
            }, {
              icon: MapPin,
              text: 'Adaptado a Argentina'
            }, {
              icon: Package,
              text: '6 Tomos Completos'
            }].map((badge, i) => <div key={i} className="flex items-center gap-2 bg-white/5 border border-white/10 px-3 py-1.5 rounded-lg text-xs font-medium text-stone-200" data-id="element-33">
                  <badge.icon size={14} className="text-brand-orange" data-id="element-34" />
                  {badge.text}
                </div>)}
            </div>

            <div data-id="element-35">
              <ButtonCTA href="#planes" variant="orange" className="text-lg py-4 px-10 font-semibold shadow-lg shadow-brand-orange/30" data-id="element-36">
                QUIERO MI MEGAPACK AHORA
              </ButtonCTA>

              <div className="flex items-center gap-5 mt-5 text-xs text-stone-400 font-medium uppercase tracking-wider" data-id="element-37">
                <span className="flex items-center gap-1.5" data-id="element-38">
                  <Shield size={14} className="text-brand-gold" data-id="element-39" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1.5" data-id="element-40">
                  <Lock size={14} className="text-brand-gold" data-id="element-41" /> Pago seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-42">
                  <CreditCard size={14} className="text-brand-gold" data-id="element-43" /> Mercado
                  Pago
                </span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-44">
            <div className="relative w-full max-w-md lg:max-w-lg bg-[#F3F1EE] rounded-3xl p-6 md:p-8 shadow-2xl shadow-black/40 ring-1 ring-white/10" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/p5Qv2zArjfoWstD8u3QPZ5/Master_Burger.png" alt="Master Burger Argentina - El Pack Más Completo con 6 Tomos" className="w-full object-contain" data-id="element-46" />
            </div>
          </div>
        </div>
      </section>

      {/* STATS BAR */}
      <section className="bg-[#1A1512] border-y border-white/10 py-8 px-4" data-id="element-47">
        <div className="max-w-5xl mx-auto flex flex-wrap justify-center md:justify-between items-center gap-8 text-center" data-id="element-48">
          <div data-id="element-49">
            <span className="block text-3xl font-display text-white mb-1" data-id="element-50">
              +500
            </span>
            <span className="text-xs text-stone-400 uppercase tracking-wider font-medium" data-id="element-51">
              Emprendedores
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-52"></div>
          <div data-id="element-53">
            <span className="block text-3xl font-display text-white mb-1" data-id="element-54">
              6
            </span>
            <span className="text-xs text-stone-400 uppercase tracking-wider font-medium" data-id="element-55">
              Tomos Listos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-56"></div>
          <div data-id="element-57">
            <span className="block text-3xl font-display text-white mb-1" data-id="element-58">
              6
            </span>
            <span className="text-xs text-stone-400 uppercase tracking-wider font-medium" data-id="element-59">
              Bonos Incluidos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-60"></div>
          <div data-id="element-61">
            <span className="block text-3xl font-display text-brand-gold mb-1" data-id="element-62">
              4.9/5
            </span>
            <span className="text-xs text-stone-400 uppercase tracking-wider font-medium" data-id="element-63">
              Calificación Media
            </span>
          </div>
        </div>
      </section>

      {/* HERO TESTIMONIALS */}
      <section className="py-20 px-4 bg-[#14110F]" data-id="element-64">
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-65">
          {TESTIMONIALS_HERO.map((t, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} key={i} className="bg-white/5 border border-white/10 p-8 rounded-2xl" data-id="element-66">
              <div className="flex text-brand-gold mb-4" data-id="element-67">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-68" />)}
              </div>
              <p className="text-stone-300 font-medium mb-6 leading-relaxed text-sm" data-id="element-69">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-70">
                <Avatar src={t.img} name={t.name} initials={t.initials} sizeClass="w-10 h-10" data-id="element-71" />
                <div data-id="element-72">
                  <p className="font-semibold text-white text-sm" data-id="element-73">{t.name}</p>
                  <p className="text-[11px] text-stone-500 uppercase tracking-wider" data-id="element-74">
                    {t.loc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="py-24 px-4 bg-[#1A1512] border-y border-white/10" data-id="element-75">
        <div className="max-w-3xl mx-auto" data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-display text-center mb-6 text-white" data-id="element-77">
            ¿Cuántos fines de semana más vas a seguir improvisando?
          </h2>
          <p className="text-lg text-center text-stone-400 mb-12 font-light leading-relaxed" data-id="element-78">
            Querés emprender con hamburguesas. Sabés que hay demanda. Pero nadie
            te dijo que ibas a pasar los domingos sin saber qué comprar, cuánto
            cobrar o cómo organizar la producción.{' '}
            <span className="font-medium text-stone-100" data-id="element-79">
              No es falta de ganas. Es falta de un sistema.
            </span>
          </p>

          <div className="space-y-3 mb-16" data-id="element-80">
            {PAIN_POINTS.map((point, i) => <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} key={i} className="flex items-start gap-4 bg-white/5 border border-white/10 p-5 rounded-xl" data-id="element-81">
                <div className="text-red-400 mt-0.5" data-id="element-82">
                  <X size={20} strokeWidth={2.5} data-id="element-83" />
                </div>
                <p className="font-medium text-stone-300" data-id="element-84">{point}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-85">
            <h3 className="text-xl font-display text-white" data-id="element-86">
              ¿Y si este fuera el último fin de semana que pasás así?
            </h3>
          </div>
        </div>
      </section>

      {/* THE SOLUTION - TOMOS */}
      <section className="py-24 px-4 bg-[#14110F]" data-id="element-87">
        <div className="max-w-5xl mx-auto" data-id="element-88">
          <div className="text-center mb-16" data-id="element-89">
            <span className="text-brand-orange text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-90">
              De Cero a Negocio Consolidado
            </span>
            <h2 className="text-3xl md:text-5xl font-display mb-4 text-white" data-id="element-91">
              El MegaPack Completo
            </h2>
            <p className="text-lg font-light text-stone-400" data-id="element-92">
              6 Tomos + 6 Bonos. Todo resuelto.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-93">
            {TOMOS.map((tomo, i) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={tomo.id} className={`bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-brand-orange/40 hover:-translate-y-0.5 transition-all border-l-4 ${tomo.color}`} data-id="element-94">
                <span className="text-stone-500 text-xs font-bold tracking-widest uppercase mb-2 block" data-id="element-95">
                  Tomo {tomo.id}
                </span>
                <h3 className="text-xl font-display mb-1 text-white" data-id="element-96">
                  {tomo.title}
                </h3>
                <p className="text-brand-orange text-sm font-medium mb-4" data-id="element-97">
                  {tomo.subtitle}
                </p>
                <p className="text-stone-400 text-sm leading-relaxed font-light" data-id="element-98">
                  {tomo.desc}
                </p>
              </motion.div>)}
          </div>

          <div className="mt-16 bg-white/5 border border-white/10 rounded-2xl p-8 max-w-3xl mx-auto" data-id="element-99">
            <h4 className="text-sm font-bold tracking-widest uppercase text-center mb-8 text-brand-gold" data-id="element-100">
              El sistema incluye
            </h4>
            <div className="grid md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-101">
              {['Paso a paso adaptado al mercado argentino', 'Insumos conseguibles en cualquier barrio', 'Fichas técnicas listas para completar', 'Criterios de selección de proveedores', 'Checklists de producción y servicio', 'Estrategias para economía inflacionaria', 'Scripts de venta para WhatsApp', 'Adaptado al emprendedor doméstico'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-102">
                  <Check className="text-brand-orange flex-shrink-0 mt-0.5" size={16} data-id="element-103" />
                  <span className="text-stone-300 text-sm font-light" data-id="element-104">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* THE BONUSES */}
      <section className="py-24 px-4 bg-[#1A1512] border-y border-white/10" data-id="element-105">
        <div className="max-w-5xl mx-auto" data-id="element-106">
          <div className="text-center mb-16" data-id="element-107">
            <h2 className="text-3xl md:text-4xl font-display text-white mb-4" data-id="element-108">
              6 Bonos Estratégicos
            </h2>
            <p className="text-brand-orange font-semibold tracking-wide uppercase text-sm" data-id="element-109">
              Siempre incluidos con tu acceso
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-110">
            {BONOS.map((bono, i) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={bono.id} className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col hover:border-brand-orange/40 transition-colors" data-id="element-111">
                <span className="text-brand-gold text-xs font-bold tracking-widest uppercase mb-2 block" data-id="element-112">
                  Bono {bono.id}
                </span>
                <h3 className="text-lg font-semibold text-white mb-3 leading-tight" data-id="element-113">
                  {bono.title}
                </h3>
                <p className="text-stone-400 text-sm font-light mb-6 flex-grow" data-id="element-114">
                  {bono.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-115">
                  <span className="text-stone-500 line-through text-sm" data-id="element-116">
                    {bono.value}
                  </span>
                  <span className="text-brand-orange font-bold text-sm uppercase tracking-wider" data-id="element-117">
                    Gratis
                  </span>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-118">
            <div className="inline-block bg-white/5 border border-white/10 py-6 px-10 rounded-2xl" data-id="element-119">
              <p className="text-xs text-stone-400 font-bold uppercase tracking-widest mb-2" data-id="element-120">
                Valor total en bonos
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-121">
                <span className="line-through text-stone-500 text-2xl font-light" data-id="element-122">
                  $53.000
                </span>
                <ArrowRight className="text-stone-600" size={20} data-id="element-123" />
                <span className="text-brand-orange font-display text-3xl" data-id="element-124">
                  GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="py-24 px-4 bg-[#14110F] border-b border-white/10" data-id="element-125">
        <div className="max-w-5xl mx-auto" data-id="element-126">
          <div className="text-center mb-16" data-id="element-127">
            <div className="inline-flex items-center gap-2 text-red-400 font-semibold text-sm uppercase tracking-wider mb-2" data-id="element-128">
              <Clock size={16} data-id="element-129" /> Precio de Lanzamiento
            </div>
            <CountdownTimer data-id="element-130" />
            <p className="text-stone-400 text-sm flex items-center justify-center gap-1.5 mt-2" data-id="element-131">
              <AlertCircle size={14} data-id="element-132" /> El precio se actualizará pronto.
            </p>

            <div className="max-w-xs mx-auto mt-8" data-id="element-133">
              <div className="flex justify-between text-xs font-semibold text-stone-400 uppercase tracking-wider mb-2" data-id="element-134">
                <span data-id="element-135">Cupos disponibles</span>
                <span className="text-white" data-id="element-136">Pocos</span>
              </div>
              <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden" data-id="element-137">
                <div className="bg-brand-orange h-2 rounded-full" style={{
                width: '82%'
              }} data-id="element-138"></div>
              </div>
            </div>
          </div>

          <div id="planes" className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto scroll-mt-28" data-id="element-139">
            {/* Standard Pack */}
            <div className="bg-white/5 border border-white/10 rounded-3xl p-8 flex flex-col" data-id="element-140">
              <h3 className="text-xl font-display text-white mb-1" data-id="element-141">
                MegaPack Master Burger Argentina
              </h3>
              <p className="text-brand-orange font-medium text-sm mb-4" data-id="element-142">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-stone-400 text-sm font-light mb-8 pb-8 border-b border-white/10" data-id="element-143">
                Ideal para emprendedores que arrancan desde cero en casa,
                quincho o patio.
              </p>

              <div className="mb-8" data-id="element-144">
                <span className="text-stone-500 line-through text-lg block mb-1" data-id="element-145">
                  $65.000
                </span>
                <div className="flex items-baseline gap-1" data-id="element-146">
                  <span className="text-4xl font-display text-white" data-id="element-147">
                    $19.990
                  </span>
                  <span className="text-stone-400 font-medium" data-id="element-148">ARS</span>
                </div>
              </div>

              <ButtonCTA href="https://www.novadigital.center/cart/48624582066431:1" variant="outline" className="mt-auto" data-id="element-149">
                QUIERO MI MASTER BURGER ARGENTINA
              </ButtonCTA>
            </div>

            {/* PRO Pack */}
            <div className="bg-gradient-to-b from-white/[0.07] to-white/[0.02] border-2 border-brand-gold/50 rounded-3xl p-8 shadow-2xl shadow-brand-gold/10 flex flex-col relative" data-id="element-150">
              <div className="absolute -top-3 left-8 bg-brand-gold text-[#14110F] text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full" data-id="element-151">
                Recomendado
              </div>
              <h3 className="text-xl font-display text-white mb-1" data-id="element-152">
                Master Burger PRO ⭐
              </h3>
              <p className="text-stone-200 font-medium text-sm mb-4" data-id="element-153">
                Todo lo anterior +{' '}
                <span className="text-brand-orange" data-id="element-154">
                  Kit Escalado Profesional
                </span>
              </p>
              <p className="text-stone-400 text-sm font-light mb-8 pb-8 border-b border-white/10" data-id="element-155">
                Ideal para emprendedores que quieren ir del quincho al negocio
                establecido más rápido.
              </p>

              <div className="mb-8" data-id="element-156">
                <span className="text-stone-500 line-through text-lg block mb-1" data-id="element-157">
                  $89.000
                </span>
                <div className="flex items-baseline gap-1" data-id="element-158">
                  <span className="text-4xl font-display text-white" data-id="element-159">
                    $27.990
                  </span>
                  <span className="text-brand-gold font-medium" data-id="element-160">ARS</span>
                </div>
              </div>

              <ButtonCTA href="https://www.novadigital.center/cart/48624587014399:1" variant="orange" className="mt-auto" data-id="element-161">
                QUIERO EL MASTER BURGER PRO
              </ButtonCTA>
            </div>
          </div>
        </div>
      </section>

      {/* PRO KIT COMPARISON */}
      <section className="py-24 px-4 bg-[#1A1512]" data-id="element-162">
        <div className="max-w-4xl mx-auto" data-id="element-163">
          <h2 className="text-2xl md:text-3xl font-display text-center text-white mb-12" data-id="element-164">
            ¿Qué agrega el Kit Escalado Profesional?
          </h2>

          <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden mb-12" data-id="element-165">
            <div className="overflow-x-auto" data-id="element-166">
              <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-167">
                <thead data-id="element-168">
                  <tr className="bg-white/5 border-b border-white/10 text-xs uppercase tracking-wider text-stone-400" data-id="element-169">
                    <th className="p-5 font-semibold w-1/3" data-id="element-170">Situación</th>
                    <th className="p-5 font-semibold w-1/3" data-id="element-171">Sin Kit</th>
                    <th className="p-5 font-semibold w-1/3 text-brand-orange" data-id="element-172">
                      Con Kit PRO
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm" data-id="element-173">
                  {COMPARISON.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0" data-id="element-174">
                      <td className="p-5 text-white font-medium" data-id="element-175">{row.sit}</td>
                      <td className="p-5 text-stone-400" data-id="element-176">{row.sin}</td>
                      <td className="p-5 text-stone-100 font-medium bg-brand-orange/10" data-id="element-177">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* MORE TESTIMONIALS */}
      <section className="py-24 px-4 bg-[#14110F] border-y border-white/10" data-id="element-178">
        <div className="max-w-5xl mx-auto" data-id="element-179">
          <h2 className="text-2xl md:text-3xl font-display text-center text-white mb-12" data-id="element-180">
            Más emprendedores que ya lo aplican
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
            {TESTIMONIALS_MORE.map((t, i) => <div key={i} className="bg-white/5 border border-white/10 p-6 rounded-2xl" data-id="element-182">
                <div className="flex justify-between items-start mb-4" data-id="element-183">
                  <div className="flex text-brand-gold" data-id="element-184">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-185" />)}
                  </div>
                  <span className="text-[10px] font-bold tracking-wider text-stone-500 uppercase" data-id="element-186">
                    {t.pack}
                  </span>
                </div>
                <p className="text-stone-300 font-light mb-6 text-sm leading-relaxed" data-id="element-187">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-188">
                  <Avatar src={t.img} name={t.name} initials={t.init} sizeClass="w-9 h-9" data-id="element-189" />
                  <div data-id="element-190">
                    <p className="font-semibold text-white text-xs" data-id="element-191">{t.name}</p>
                    <p className="text-[10px] text-stone-500 uppercase tracking-wider" data-id="element-192">
                      {t.loc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-20 px-4 bg-[#1A1512] border-b border-white/10 text-center" data-id="element-193">
        <div className="max-w-2xl mx-auto bg-white/5 border border-brand-gold/30 rounded-3xl p-10" data-id="element-194">
          <Shield size={48} className="mx-auto mb-6 text-brand-gold" strokeWidth={1.5} data-id="element-195" />
          <h2 className="text-2xl md:text-3xl font-display mb-4 text-white" data-id="element-196">
            Garantía de 7 Días
          </h2>
          <p className="text-lg font-light text-stone-300 mb-6" data-id="element-197">
            Revisá el material y aplicalo en tu emprendimiento. Si no es lo que
            esperabas, solicitás la devolución del 100% sin preguntas.
          </p>
          <p className="text-xs font-semibold uppercase tracking-widest text-stone-500" data-id="element-198">
            Tasa de devoluciones: menor al 1%
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 px-4 bg-[#14110F]" data-id="element-199">
        <div className="max-w-2xl mx-auto" data-id="element-200">
          <h2 className="text-2xl md:text-3xl font-display text-center text-white mb-10" data-id="element-201">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-3" data-id="element-202">
            {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} data-id="element-203" />)}
          </div>
        </div>
      </section>

      {/* COST OF INACTION */}
      <section className="py-24 px-4 bg-[#1A1512] border-t border-white/10" data-id="element-204">
        <div className="max-w-3xl mx-auto" data-id="element-205">
          <h2 className="text-2xl md:text-3xl font-display text-center text-white mb-12" data-id="element-206">
            ¿Cuánto cuesta no tener un sistema?
          </h2>

          <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden mb-12" data-id="element-207">
            <table className="w-full text-left border-collapse" data-id="element-208">
              <thead data-id="element-209">
                <tr className="bg-white/5 border-b border-white/10 text-xs uppercase tracking-wider text-stone-400" data-id="element-210">
                  <th className="p-5 font-semibold w-1/2" data-id="element-211">Sin el MegaPack</th>
                  <th className="p-5 font-semibold w-1/2" data-id="element-212">Costo Real</th>
                </tr>
              </thead>
              <tbody className="text-sm" data-id="element-213">
                {COST_INACTION.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0" data-id="element-214">
                    <td className="p-5 text-stone-400 flex items-center gap-2" data-id="element-215">
                      <X size={14} className="text-red-400 flex-shrink-0" data-id="element-216" />{' '}
                      {row.sin}
                    </td>
                    <td className="p-5 text-white font-medium" data-id="element-217">{row.costo}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center" data-id="element-218">
            <p className="text-lg font-medium text-white mb-2" data-id="element-219">
              El próximo fin de semana puede ser diferente.
            </p>
            <p className="text-stone-400 font-light" data-id="element-220">
              Empezá a operar con un sistema real detrás.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-24 px-4 bg-[#14110F] text-center border-t border-white/10" data-id="element-221">
        <div className="max-w-3xl mx-auto" data-id="element-222">
          <h2 className="text-3xl font-display mb-8 text-white" data-id="element-223">
            Estás a un paso de profesionalizar tu negocio.
          </h2>

          <div className="bg-white/5 border border-brand-gold/30 rounded-2xl p-8 mb-12 max-w-xl mx-auto" data-id="element-224">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-225">
              <div className="text-left" data-id="element-226">
                <h3 className="text-lg font-display text-white mb-1" data-id="element-227">
                  Master Burger PRO ⭐
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-228">
                  <span className="text-stone-500 line-through text-sm" data-id="element-229">
                    $89.000
                  </span>
                  <span className="text-2xl font-display text-brand-orange" data-id="element-230">
                    $27.990
                  </span>
                  <span className="text-stone-400 text-xs font-medium" data-id="element-231">
                    ARS
                  </span>
                </div>
              </div>
              <ButtonCTA href="https://www.novadigital.center/cart/48624587014399:1" variant="orange" className="w-full md:w-auto px-8 py-3 text-base" data-id="element-232">
                QUIERO EL MASTER BURGER PRO
              </ButtonCTA>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 text-xs text-stone-400 font-medium uppercase tracking-wider mb-16" data-id="element-233">
            <span className="flex items-center gap-1.5" data-id="element-234">
              <Lock size={14} className="text-brand-gold" data-id="element-235" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-236">
              <Zap size={14} className="text-brand-gold" data-id="element-237" /> Acceso Inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-238">
              <Shield size={14} className="text-brand-gold" data-id="element-239" /> Garantía
            </span>
          </div>
        </div>
      </section>

      <footer className="bg-[#0F0D0B] text-stone-500 py-12 px-4 text-center text-xs border-t border-white/10" data-id="element-240">
        <div className="max-w-4xl mx-auto" data-id="element-241">
          <h4 className="text-sm font-display text-stone-300 mb-2 uppercase tracking-widest" data-id="element-242">
            Master Burger Argentina™
          </h4>
          <p className="mb-8 font-light" data-id="element-243">
            El sistema integral para hamburgueserías caseras.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-8 uppercase tracking-wider" data-id="element-244">
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-245">
              Soporte
            </a>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-246">
              Instagram
            </a>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-247">
              Sitio Web
            </a>
          </div>

          <p data-id="element-248">© Nova Digital™ 2024 — Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>;
}